import { render, staticRenderFns } from "./related_products.vue?vue&type=template&id=04b905eb&"
import script from "./related_products.vue?vue&type=script&lang=ts&"
export * from "./related_products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports